var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-10px"},[(_vm.loading)?_c('loader',{attrs:{"centered":true}}):_c('div',[_c('v-calendar',{ref:"calendar",attrs:{"weekdays":[1, 2, 3, 4, 5, 6, 0],"type":"month","events":_vm.events}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }